import { ActionFlag } from '@makyoapp/makyo-common'

import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { hasActionFlag } from '@/shared/builder-utils'

import MenuPanelEdit from './components/MenuPanel/MenuPanelEdit'
import MenuPanelNormal from './components/MenuPanel/MenuPanelNormal'

/**
 * builder leading-sidebar menu panel
 */
export function MenuPanel() {
  const { menuAction } = useAppBuilderContext()
  return (
    <div className='menu-panel mk-builder-panel'>
      {menuAction && hasActionFlag(menuAction.flag, ActionFlag.Edit) ? (
        <MenuPanelEdit menu={menuAction.menu} />
      ) : (
        <MenuPanelNormal />
      )}
    </div>
  )
}
